import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import { FcaServiceTypeCollectionItem } from '@/types/responses/fca-service-types'

class FcaServiceTypeService {
  public async getAll(): Promise<FcaServiceTypeCollectionItem> {
    const response = await apiService.get(
      `${API_PATH_INTERNAL}/fca-service-types`,
    )

    return response.data['hydra:member']
  }
}

const fcaServiceTypeService = new FcaServiceTypeService()

export default fcaServiceTypeService
